import type { SpreadLayoutTemplate } from './layout-types';

export const CROSSED_3_LAYOUT: SpreadLayoutTemplate = {
  id: 'crossed-3',
  family: 'cross',
  cards: 3,
  description: 'Tre carte incrociate per tensione, ostacolo e consiglio con gerarchia visuale esplicita.',
  supports_focus_overlay: true,
  variants: [
    {
      id: 'portrait',
      points: [
        { x: 30, y: 50, z: 1 },
        { x: 50, y: 50, z: 2 },
        { x: 70, y: 50, z: 1 },
      ],
      card_rotation: [0, 90, 0],
    },
    {
      id: 'compact',
      points: [
        { x: 28, y: 54, z: 1 },
        { x: 50, y: 54, z: 2 },
        { x: 72, y: 54, z: 1 },
      ],
      card_rotation: [0, 90, 0],
    },
  ],
};
